module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstsmall",
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("InterVarsity Press"), _c('br'), _vm._v("\n  P.O. Box 1400"), _c('br'), _vm._v("\n  Downers Grove, IL 60515-1426"), _c('br'), _vm._v("\n  World Wide Web: "), _c('a', {
    attrs: {
      "href": "http://www.ivpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ivpress.com")]), _c('br'), _vm._v("\n  E-mail: "), _c('a', {
    attrs: {
      "href": "mailto:email@ivpress.com"
    }
  }, [_vm._v("email@ivpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("© 2013 by Ron Highfield")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept. InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at "), _c('a', {
    attrs: {
      "href": "http://www.intervarsity.org",
      "target": "_blank"
    }
  }, [_vm._v("www.intervarsity.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("All Scripture quotations, unless otherwise indicated, are taken from the "), _c('em', [_vm._v("Holy Bible, Today’s New International Version")]), _vm._v("®, NIV® Copyright © 1973, 1978, 1984, 2010 by Biblica, Inc.tm Used by permission. All rights reserved worldwide."), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("Cover design: Cindy Kiple"), _c('br'), _vm._v("\n  Interior design: Beth Hagenberg"), _c('br'), _vm._v("\n  Images: Hand print: © GANNA RASSADNIKOVA/iStockphoto")]), _vm._v(" "), _c('p', {
    staticClass: "firstsmall"
  }, [_vm._v("ISBN 978-0-8308-6450-8")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 60
// module chunks = 0